import { z } from "zod";

import { ExploreFieldOverrides } from "../../explore/types.js";

export interface ExploreSpecSessionStateUpdatableFields {
  fieldOverrides: ExploreFieldOverrides | null;
}

const _UpdateExploreSpecSessionStateSafeFields: {
  [key in keyof ExploreSpecSessionStateUpdatableFields]: "";
} = {
  fieldOverrides: "",
};
export const UpdateExploreSpecSessionStateSafeFields = Object.keys(
  _UpdateExploreSpecSessionStateSafeFields,
);

/** Shared by the CREATE `options` bag and the UPDATE `key`/`value` pair. */
export const EXPLORE_SPEC_SESSION_STATE_FIELDS = {
  fieldOverrides: ExploreFieldOverrides.nullable(),
} satisfies Record<keyof ExploreSpecSessionStateUpdatableFields, z.ZodTypeAny>;
